import { EPageTypeGetParam } from '@/enums/EPageTypeGetParam';
import { useCallback } from 'react';
import { use_navigate_ud } from '../../../../hooks/_base/use_navigate_ud';

export function use_grid2d_slug_offset_set_to_url() {
  const navigate = use_navigate_ud();

  return useCallback(
    (value: number) => {
      const url = new URL(window.location.href);
      url.searchParams.set(EPageTypeGetParam.GRID2D_OFFSET, String(value));

      void navigate(`${url.pathname}${url.search}`);
    },
    [navigate],
  );
}
